import React, { useState, useEffect } from 'react';
import { apprenantsAPI, configAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import Modal from './Modal';
import FormInput from './FormInput';
import FormSelect from './FormSelect';
import Icon from './Icon';

const ModalChangementEntreprise = ({ isOpen, onClose, apprenant, onUpdate }) => {
  const { isFormateur } = useAuth();
  const [formData, setFormData] = useState({
    entreprise: '',
    contactSuperviseur: '',
    typeContrat: '',
    dateChangement: new Date().toISOString().split('T')[0],
    nouveauPoste: ''
  });
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchConfig();
  }, []);

  useEffect(() => {
  if (!apprenant) return;
  const dernierChangement = apprenant.changementsEntreprise?.length > 0
    ? apprenant.changementsEntreprise[apprenant.changementsEntreprise.length - 1]
    : null;
  setFormData(prev => ({
    ...prev,
    entreprise: dernierChangement?.entreprise || apprenant.entreprise || '',
    typeContrat: dernierChangement?.typeContrat || apprenant.typeContrat || '',
    nouveauPoste: dernierChangement?.poste || apprenant.poste || '',
  }));
}, [apprenant]);

  const fetchConfig = async () => {
    try {
      const response = await configAPI.get();
      setConfig(response.data);
    } catch (error) {
      toast.error('Erreur lors du chargement de la configuration');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormateur) {
      toast.error('Pas de droits');
      return;
    }

    setLoading(true);
    try {
      await apprenantsAPI.addChangementEntreprise(apprenant._id, formData);
      toast.success('Changement d\'entreprise enregistré !');
      onUpdate && onUpdate();
      onClose();
      setFormData({
        entreprise: '',
        contactSuperviseur: '',
        typeContrat: '',
        dateChangement: new Date().toISOString().split('T')[0],
        nouveauPoste: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors de l\'enregistrement');
    } finally {
      setLoading(false);
    }
  };

  if (!config) {
    return null;
  }

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={
        <span className="flex items-center">
          <Icon name="refresh" size={20} className="mr-2" />
          Changement Entreprise
        </span>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormInput
          label="Nouvelle entreprise"
          name="entreprise"
          value={formData.entreprise}
          onChange={handleChange}
          required
        />
        <FormInput
          label="Contact superviseur"
          name="contactSuperviseur"
          type="tel"
          value={formData.contactSuperviseur}
          onChange={handleChange}
          required
        />
        <FormSelect
          label="Type contrat"
          name="typeContrat"
          value={formData.typeContrat}
          onChange={handleChange}
          required
          options={config.typesContrat || []}
        />
        <FormInput
          label="Date changement"
          name="dateChangement"
          type="date"
          value={formData.dateChangement}
          onChange={handleChange}
          required
        />
        <FormInput
          label="Nouveau poste"
          name="nouveauPoste"
          value={formData.nouveauPoste}
          onChange={handleChange}
        />
        <div className="flex gap-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={loading}
            className="flex-1 p-2 gap-3 bg-blue-600 text-white rounded-lg disabled:opacity-50 hover:bg-blue-700"
          >
            {/* <Icon name={loading ? 'refresh' : 'save'} size={18} className={loading ? 'animate-spin' : ''} /> */}
            <span>{loading ? 'Enregistrement...' : 'Enregistrer'}</span>
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ModalChangementEntreprise;

